export function dateToStr(date) {
  return date.toISOString().replace(/T.*$/, ""); // YYYY-MM-DD of today
}
